"use client";
import imageOne from "../assests/Images/business-people-casual-meeting-min.jpg";
import imagetwo from "../assests/Images/Organization-Design.jpg";
import { FaArrowRight } from "react-icons/fa";
import imageThree from "../assests/Images/top-view-wooden-pawns-arrangement-min.jpg";
import imageFour from "../assests/Images/TALENT-AQU.jpg";
import { TbBlocks } from "react-icons/tb";
import { FaHeadSideVirus } from "react-icons/fa";
import { ImProfile } from "react-icons/im";
import { FaPeopleGroup } from "react-icons/fa6";
import { IoIosPeople } from "react-icons/io";
import { FaChartPie } from "react-icons/fa";
import { FaHandHoldingUsd } from "react-icons/fa";
import { PiMagnifyingGlassFill } from "react-icons/pi";
import { IoLockClosed } from "react-icons/io5";
import { RiSecurePaymentFill } from "react-icons/ri";
import imageFive from "../assests/Images/payroll.png";
import imageSix from "../assests/Images/Employee_Benefits_Program.png";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import { useInView } from "react-intersection-observer";
import WaveEffect from "../Components/WaveEffect";
import { useState } from "react";
import staffingImage from "../assests/Images/StaffingheroImage.jpg";

const Staffing = () => {
  const [activeTab, setActiveTab] = useState("staffing");

  const { ref: ref2, inView: inView2 } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  const { ref: ref3, inView: inView3 } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  const { ref: ref5, inView: inView5 } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  return (
    <>
      <Navbar />
      <div
        className="bg-cover bg-center h-[75vh] lg:h-[75vh] md:h-[500px] sm:h-[400px] "
        style={{ backgroundImage: `url(${staffingImage})` }}
      >
        <div className="h-full bg-black bg-opacity-60 flex flex-col justify-center items-center px-8 lg:px-12 xl:px-12 2xl:px-12 ">
          <WaveEffect
            text="Staffing"
            textClassName="text-white text-4xl lg:text-8xl xl:text-8xl 2xl:text-8xl font-bold"
          />
          <div className="h-1 lg:h-2 xl:h-2 2xl:h-2 mt-4 w-12 bg-white" />
          <p className=" text-white text-center  md:text-xl 2xl:text-2xl mt-3">
            300+ Years of Leadership Experience Deploying the Best Talent.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mt-20">
        <div className="flex justify-center">
          <img
            src={imagetwo}
            alt="Organizational network diagram showing connected team members"
            width="500"
            height="400"
            className="rounded-3xl shadow-2xl"
          />
          `
        </div>
        <div className="space-y-8">
          <div>
            <h1 className="mb-2 bg-red-100 font-bold text-red-700 w-fit rounded-3xl text-sm px-4 py-2">
              ORGANIZATIONAL EXCELLENCE
            </h1>
            <h1 className="text-4xl font-bold  text-gray-900 leading-tight">
              Organization
              <span className="text-red-600"> Design</span>
            </h1>
            <p className=" text-gray-600 my-8 leading-relaxed">
              At People Process Tack, we understand the complexities CEOs face
              with organizational inefficiencies and internal conflicts. If your
              management team needs to view management but struggles with
              projected decision making, if customers switchbacks in seeking, it
              may indicate that your current organizational structure is
              misaligned to quality and customer demands.
            </p>
            <p className=" text-gray-600 mb-8">
              We offer comprehensive organizational assessments to evaluate
              functionality, strengths, weaknesses and alignment with your core
              ideology and business strategy.
            </p>
          </div>
          <div className="grid grid-cols-1 ">
            <div className="flex items-center space-x-4 px-4 py-1   rounded-2xl">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="lucide lucide-circle-check-big w-5 h-5 text-white"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <path d="m9 11 3 3L22 4"></path>
                </svg>
              </div>
              <span className="text-gray-700 font-medium">
                Audit and Customer focused
              </span>
            </div>
            <div className="flex items-center space-x-4 px-4 py-1  rounded-2xl ">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="lucide lucide-target w-5 h-5 text-white"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <circle cx="12" cy="12" r="6"></circle>
                  <circle cx="12" cy="12" r="2"></circle>
                </svg>
              </div>
              <span className="text-gray-700 font-medium">
                Identification of core and non-core functions and processes
              </span>
            </div>
            <div className="flex items-center space-x-4 px-4 py-1  rounded-2xl ">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="lucide lucide-trending-up w-5 h-5 text-white"
                >
                  <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                  <polyline points="16 7 22 7 22 13"></polyline>
                </svg>
              </div>
              <span className="text-gray-700 font-medium">
                Defined role and skill improvement requirements
              </span>
            </div>
            <div className="flex items-center space-x-4 px-4 py-1  rounded-2xl ">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="lucide lucide-zap w-5 h-5 text-white"
                >
                  <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path>
                </svg>
              </div>
              <span className="text-gray-700 font-medium">
                Reduce OPEX for every process and function
              </span>
            </div>
          </div>
        </div>
      </div>

      <section className="px-20 mt-20">
        <div className="flex flex-col justify-center items-center my-10 md:mt-20">
          <h1 className="mb-2 bg-red-100 font-bold text-red-700 w-fit rounded-3xl text-sm px-4 py-2">
            TRANSFORMATION PROCESS
          </h1>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">STEPS</h2>
          <p>Our systematic approach to organizational transformation</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
          <div
            className="group rounded-lg  cursor-pointer transition-all duration-500 hover:scale-105 border-0 shadow-xl bg-blue-100  hover:shadow-2xl hover:bg-primary hover:bg-opacity-95"
            data-v0-t="card"
          >
            <div className="flex flex-col space-y-1.5 p-6 text-center pb-4">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 bg-primary text-blue-100 group-hover:text-primary group-hover:bg-blue-100 transition-all duration-500 ">
                <span className="text-2xl font-bold">01</span>
              </div>
              <h3 className="tracking-tight text-lg font-bold text-gray-900 group-hover:text-white">
                Organization Design Principle
              </h3>
            </div>
            <div className="p-6 pt-0 text-center ">
              <p className="text-sm text-gray-600 group-hover:text-white">
                Craft a structure that embodies your company’s vision, mission,
                and business strategy
              </p>
            </div>
          </div>

          <div
            className="group rounded-lg  cursor-pointer transition-all duration-500 hover:scale-105 border-0 shadow-xl bg-blue-100  hover:shadow-2xl hover:bg-primary hover:bg-opacity-95"
            data-v0-t="card"
          >
            <div className="flex flex-col space-y-1.5 p-6 text-center pb-4">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 bg-primary text-blue-100 group-hover:text-primary group-hover:bg-blue-100 transition-all duration-500 ">
                <span className="text-2xl font-bold">02</span>
              </div>
              <h3 className="tracking-tight text-lg font-bold text-gray-900 group-hover:text-white">
                Define Structure Policies and Procedures
              </h3>
            </div>
            <div className="p-6 pt-0 text-center ">
              <p className="text-sm text-gray-600 group-hover:text-white">
                Establish clear job descriptions, identify key positions, and
                upgrade processes and technology
              </p>
            </div>
          </div>

          <div
            className="group rounded-lg  cursor-pointer transition-all duration-500 hover:scale-105 border-0 shadow-xl bg-blue-100  hover:shadow-2xl hover:bg-primary hover:bg-opacity-95"
            data-v0-t="card"
          >
            <div className="flex flex-col space-y-1.5 p-6 text-center pb-4">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 bg-primary text-blue-100 group-hover:text-primary group-hover:bg-blue-100 transition-all duration-500 ">
                <span className="text-2xl font-bold">03</span>
              </div>
              <h3 className="tracking-tight text-lg font-bold text-gray-900 group-hover:text-white">
                Streamline Functions and Processes
              </h3>
            </div>
            <div className="p-6 pt-0 text-center ">
              <p className="text-sm text-gray-600 group-hover:text-white">
                Distinguish between core and non-core functions, assess resource
                needs, and optimize accordingly
              </p>
            </div>
          </div>

          <div
            className="group rounded-lg  cursor-pointer transition-all duration-500 hover:scale-105 border-0 shadow-xl bg-blue-100  hover:shadow-2xl hover:bg-primary hover:bg-opacity-95"
            data-v0-t="card"
          >
            <div className="flex flex-col space-y-1.5 p-6 text-center pb-4">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 bg-primary text-blue-100 group-hover:text-primary group-hover:bg-blue-100 transition-all duration-500 ">
                <span className="text-2xl font-bold">04</span>
              </div>
              <h3 className="tracking-tight text-lg font-bold text-gray-900 group-hover:text-white">
                Deploy and Manage Change
              </h3>
            </div>
            <div className="p-6 pt-0 text-center ">
              <p className="text-sm text-gray-600 group-hover:text-white">
                Implement manpower deployment strategies, track key performance
                metrics, and ensure a seamless transition to the new structure
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <div ref={ref2} className={`bg-gray-100 h-[68rem] lg:h-[43rem] xl:h-[43rem] 2xl:h-[43rem] grid lg:grid-cols-3 p-4 pt-14 mt-10 gap-4 pb-8 `}>
        <div className="bg-center bg-cover rounded-md" style={{ backgroundImage: `url(${imageThree})` }}>
          <div className="h-full bg-primary/90 rounded-md flex flex-col items-center justify-center gap-4 p-4">
            <h1 className={`text-white text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold ${inView2 ? 'animate-slideInFromTop' : ''}`}>STEP 1</h1>
            <p className={`text-white text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl text-center ${inView2 ? 'animate-slideInFromTop' : ''}`}>Organization Design Principle</p>
            <p className={`lg:text-xl xl:text-xl 2xl:text-xl text-white text-center leading-6 animate-slideInFromTop`}>Craft a structure that embodies your company’s vision, mission, and business strategy</p>
          </div>
        </div>
        <div className="bg-center bg-cover rounded-md" style={{ backgroundImage: `url(${imageThree})` }}>
          <div className="h-full bg-primary/90 rounded-md flex flex-col items-center justify-center gap-4 p-4">
            <h1 className={`text-white text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold ${inView2 ? 'animate-slideInFromTop' : ''}`}>STEP 2</h1>
            <p className={`text-white text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl text-center ${inView2 ? 'animate-slideInFromTop' : ''} `}>Define Structure Policies and Procedures</p>
            <p className="lg:text-xl xl:text-xl 2xl:text-xl text-white text-center leading-6 animate-slideInFromTop">Establish clear job descriptions, identify key positions, and upgrade processes and technology</p>
          </div>
        </div>
        <div className="bg-center bg-cover rounded-md" style={{ backgroundImage: `url(${imageThree})` }}>
          <div className="h-full bg-primary/90 rounded-md flex flex-col items-center justify-center gap-4 p-4">
            <h1 className={`text-white text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold  ${inView2 ? 'animate-slideInFromTop' : ''}`}>STEP 3</h1>
            <p className={`text-white text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl text-center  ${inView2 ? 'animate-slideInFromTop' : ''}`}>Streamline Functions and Processes</p>
            <p className={`lg:text-xl xl:text-xl 2xl:text-xl text-white text-center leading-6  ${inView2 ? 'animate-slideInFromTop' : ''}`}>Distinguish between core and non-core functions, assess resource needs, and optimize accordingly</p>
          </div>
        </div>
        <div className="bg-center bg-cover rounded-md" style={{ backgroundImage: `url(${imageThree})` }}>
          <div className="h-full bg-primary/90 rounded-md flex flex-col items-center justify-center gap-4 p-4">
            <h1 className={`text-white text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold  ${inView2 ? 'animate-slideInFromTop' : ''}`}>STEP 4</h1>
            <p className={`text-white text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl text-center  ${inView2 ? 'animate-slideInFromTop' : ''}`}>Deploy and Manage Change</p>
            <p className={`lg:text-xl xl:text-xl 2xl:text-xl text-white text-center leading-6  ${inView2 ? 'animate-slideInFromTop' : ''}`}>Implement manpower deployment strategies, track key performance metrics, and ensure a seamless transition to the new structure</p>
          </div>
        </div>
      </div> */}

      <section className="md:my-32 my-10">
        <div className="text-center my-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Talent Acquisition
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive talent solutions tailored to your organizational needs
          </p>
        </div>

        <div className=" w-full">
          {/* Tab Buttons */}
          <div className="grid grid-cols-1 md:grid-cols-4 mb-12 bg-gray-100 rounded-2xl p-2">
            <button
              onClick={() => setActiveTab("staffing")}
              className={`rounded-xl py-2 px-4 transition-all duration-300 ${
                activeTab === "staffing"
                  ? "bg-primary shadow-md text-white"
                  : "hover:bg-gray-200"
              }`}
            >
              Staffing & Managed Services
            </button>

            <button
              onClick={() => setActiveTab("hiring")}
              className={`rounded-xl py-2 px-4 transition-all duration-300 ${
                activeTab === "hiring"
                  ? "bg-primary shadow-md text-white"
                  : "hover:bg-gray-200"
              }`}
            >
              Pan India Hiring
            </button>

            <button
              onClick={() => setActiveTab("platform")}
              className={`rounded-xl py-2 px-4 transition-all duration-300 ${
                activeTab === "platform"
                  ? "bg-primary shadow-md text-white"
                  : "hover:bg-gray-200"
              }`}
            >
              Recruitment Platform
            </button>

            <button
              onClick={() => setActiveTab("assessment")}
              className={`rounded-xl py-2 px-4 transition-all duration-300 ${
                activeTab === "assessment"
                  ? "bg-primary shadow-md text-white"
                  : "hover:bg-gray-200"
              }`}
            >
              Assessments & Interviewing
            </button>
          </div>

          {/* Tab Contents */}
          {activeTab === "staffing" && (
            <div className="px-20">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div className="rounded-lg bg-card  border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                  <div className="p-6">
                    <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center mb-4   transition-all duration-300">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-building w-6 h-6 text-white "
                      >
                        <rect
                          width="16"
                          height="20"
                          x="4"
                          y="2"
                          rx="2"
                          ry="2"
                        ></rect>
                        <path d="M9 22v-4h6v4"></path>
                        <path d="M8 6h.01"></path>
                        <path d="M16 6h.01"></path>
                        <path d="M12 6h.01"></path>
                        <path d="M12 10h.01"></path>
                        <path d="M12 14h.01"></path>
                        <path d="M16 10h.01"></path>
                        <path d="M16 14h.01"></path>
                        <path d="M8 10h.01"></path>
                        <path d="M8 14h.01"></path>
                      </svg>
                    </div>
                    <h3 className="font-bold text-gray-900 mb-2">
                      Remotely Managed Process Outsourcing
                    </h3>
                    <p className="text-gray-600 text-sm">
                      End-to-end process management
                    </p>
                  </div>
                </div>

                <div className="rounded-lg bg-card  border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                  <div className="p-6">
                    <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center mb-4   transition-all duration-300">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-crown w-6 h-6 text-white "
                      >
                        <path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"></path>
                        <path d="M5 21h14"></path>
                      </svg>
                    </div>
                    <h3 className="font-bold text-gray-900 mb-2">
                      Managed Service Provider (MSP)
                    </h3>
                    <p className="text-gray-600 text-sm">
                      Comprehensive workforce solutions
                    </p>
                  </div>
                </div>

                <div className="rounded-lg bg-card  border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                  <div className="p-6">
                    <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center mb-4   transition-all duration-300">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-briefcase w-6 h-6 text-white "
                      >
                        <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                        <rect width="20" height="14" x="2" y="6" rx="2"></rect>
                      </svg>
                    </div>
                    <h3 className="font-bold text-gray-900 mb-2">
                      Professional Staffing
                    </h3>
                    <p className="text-gray-600 text-sm">
                      Expert professional placements
                    </p>
                  </div>
                </div>

                <div className="rounded-lg bg-card  border-0 shadow-lg hover:shadow-xl transition-all duration-300 group">
                  <div className="p-6">
                    <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center mb-4   transition-all duration-300">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-bar-chart3 w-6 h-6 text-white"
                      >
                        <path d="M3 3v18h18"></path>
                        <path d="M18 17V9"></path>
                        <path d="M13 17V5"></path>
                        <path d="M8 17v-3"></path>
                      </svg>
                    </div>
                    <h3 className="font-bold text-gray-900 mb-2">
                      Payroll Management
                    </h3>
                    <p className="text-gray-600 text-sm">
                      Complete payroll processing
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "hiring" && (
            <div className="px-16">
              <div className="space-y-4 flex justify-center items-center flex-col">
                <h3 className="text-xl font-bold">Pan India Hiring</h3>
                <p className="text-gray-600">
                  Specialized hiring services across India with local expertise
                  and national reach.
                </p>
                <div className="space-y-2">
                  <div className="flex gap-2 items-center">
                    <div className="h-3 w-3 bg-primary rounded-full"></div>
                    <h1>High Volume</h1>
                  </div>

                  <div className="flex gap-2 items-center">
                    <div className="h-3 w-3 bg-primary rounded-full"></div>
                    <h1>Multi-location Hiring</h1>
                  </div>

                  <div className="flex gap-2 items-center">
                    <div className="h-3 w-3 bg-primary rounded-full"></div>
                    <h1>
                      Coverage across functions (Ops, Sales, Support & Factory)
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "platform" && (
            <div className="px-16">
              <div className="space-y-4 flex justify-center items-center flex-col">
                <h3 className="text-xl font-bold">
                  Recruitment Platform & Products
                </h3>
                <p className="text-gray-600">
                  Advanced technology solutions for modern recruitment
                  challenges.
                </p>
                <div className="space-y-2">
                  <div className="flex gap-2 items-center">
                    <div className="h-3 w-3 bg-primary rounded-full"></div>
                    <h1>Campus ATS & Texhibit</h1>
                  </div>

                  <div className="flex gap-2 items-center">
                    <div className="h-3 w-3 bg-primary rounded-full"></div>
                    <h1>ATS – AI Enabled Recruitment Platform</h1>
                  </div>

                  <div className="flex gap-2 items-center">
                    <div className="h-3 w-3 bg-primary rounded-full"></div>
                    <h1>
                      Self Proctored Assessments & Video Interviewing Platform
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === "assessment" && (
            <div className="px-16">
              <div className="space-y-4 flex justify-center items-center flex-col">
                <h3 className="text-xl font-bold">
                  Assessments & Interviewing
                </h3>
                <div className="space-y-2">
                  <div className="flex gap-2 items-center">
                    <div className="h-3 w-3 bg-primary rounded-full"></div>
                    <h1>Composite Approach – Platform, Content & Service</h1>
                  </div>

                  <div className="flex gap-2 items-center">
                    <div className="h-3 w-3 bg-primary rounded-full"></div>
                    <h1>Interview Services across levels</h1>
                  </div>

                  <div className="flex gap-2 items-center">
                    <div className="h-3 w-3 bg-primary rounded-full"></div>
                    <h1>Dedicated Assessment Centres</h1>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <div className="mt-8 xl:my-12">
        <h1 className="text-center font-bold text-4xl xl:text-5xl">
          Payroll Processing
        </h1>

        <p className="text-lg text-center p-8 pb-0">
          Why divert valuable resources to payroll management when we can handle
          it all with our all-encompassing payroll services?
        </p>
        <h1 className="font-bold text-center mt-4">We guarantee:</h1>
        <div className="grid lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-6 xl:px-16">
          <div className="flex flex-col p-6 gap-4">
            <div className="group flex gap-2 items-center pb-6 border-b border-primary/50">
              <PiMagnifyingGlassFill className="shrink-0 text-6xl group-hover:text-primary" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                <span className="font-semibold">100% Accuracy</span>: Flawless
                payroll calculations every time.
              </h1>
            </div>
            <div className="group flex gap-2 items-center pb-6 border-b border-primary/50">
              <IoLockClosed className="shrink-0 text-6xl group-hover:text-primary" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                <span className="font-semibold">Fraud Protection</span>: Robust
                safeguards to prevent financial fraud.
              </h1>
            </div>
            <div className="group flex gap-2 items-center pb-6 ">
              <RiSecurePaymentFill className="shrink-0 text-6xl group-hover:text-primary" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                <span className="font-semibold">Secure Data Backup</span>:
                Secure Data Backup: Your data is securely stored and backed up.
              </h1>
            </div>
          </div>
          <div className="flex items-center">
            <p className="text-xl xl:text-lg leading-8 p-4 lg:p-4 xl:p-4 2xl:p-4 text-center">
              Our Payroll Service adapts to diverse industry pay structures,
              supports dynamic component creation, manages multiple salary
              revisions, and integrates with most bank upload formats—ensuring
              effortless payroll management tailored to your needs.
            </p>
          </div>
        </div>
        <div className="grid lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2  xl:px-16">
          <div className="p-6 justify-center items-center hidden lg:flex xl:flex 2xl:flex">
            <img src={imageFive} alt="" className="h-fit" />
          </div>
          <div className="flex flex-col  p-6">
            <h1 className="text-2xl font-bold text-center">
              Effortless payroll management, tailored to your needs.
            </h1>
            <p className="text-xl font-bold text-center lg:text-start xl:text-start 2xl:text-start">
              Payroll Services Include:
            </p>
            <div className="flex gap-2 items-center pb-6 border-b border-primary/50 mt-4">
              <FaArrowRight className="text-primary shrink-0 text-xl" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                Composite Approach – Platform, Content & Service
              </h1>
            </div>
            <div className="flex gap-2 items-center pb-6 border-b border-primary/50 mt-4">
              <FaArrowRight className="text-primary shrink-0 text-xl" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                Customized Reports and JV
              </h1>
            </div>
            <div className="flex gap-2 items-center pb-6 border-b border-primary/50 mt-4">
              <FaArrowRight className="text-primary shrink-0 text-xl" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                Query Management System
              </h1>
            </div>
            <div className="flex gap-2 items-center pb-6 border-b border-primary/50 mt-4">
              <FaArrowRight className="text-primary shrink-0 text-xl" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                Employee Self Service Portal (ESS)
              </h1>
            </div>
            <div className="flex gap-2 items-center pb-6 border-b border-primary/50 mt-4">
              <FaArrowRight className="text-primary shrink-0 text-xl" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                Attendance and Leave Man
              </h1>
            </div>
            <div className="flex gap-2 items-center pb-6 border-b border-primary/50 mt-4">
              <FaArrowRight className="text-primary shrink-0 text-xl" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                Expense Claim Management
              </h1>
            </div>
            <div className="flex gap-2 items-center pb-6 border-b border-primary/50 mt-4">
              <FaArrowRight className="text-primary shrink-0 text-xl" />
              <h1 className="text-lg">
                Monthly Pay Slips, Tax Slips, Reimbursement Slips
              </h1>
            </div>
            <div className="flex gap-2 items-center pb-6 border-b border-primary/50 mt-4">
              <FaArrowRight className="text-primary shrink-0 text-xl" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                F&F Settlement Process
              </h1>
            </div>
            <div className="flex gap-2 items-center pb-6 border-b border-primary/50 mt-4">
              <FaArrowRight className="text-primary shrink-0 text-xl" />
              <h1 className="lg:text-xl xl:text-lg 2xl:text-xl">
                Form 16/12BA with Digital Signature
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 xl:my-16 xl:px-16" ref={ref3}>
        {inView3 && (
          <WaveEffect
            text=" Employee Benefits Management"
            textClassName="text-2xl lg:text-4xl xl:text-5xl 2xl:text-5xl font-bold text-center"
          />
        )}
        <div className=" px:12 xl:px-14 xl:my-12">
          <p className={"text-center  lg:text-xl xl:text-lg 2xl:text-xl "}>
            Secure your employees’ financial and social well-being with our
            holistic Employee Benefits Management Program. This program reduces
            attrition rates and fosters loyalty to your organization. Our
            statutory compliance experts will assist in designing, implementing,
            and administering a tailor-made program that aligns with your
            business goals.
          </p>
          <p className={"text-center lg:text-xl xl:text-lg 2xl:text-xl mt-10"}>
            We are dedicated to partnering with you to achieve your business
            objectives with integrity and excellence. If you have any questions
            or would like to discuss our services further, please feel free to
            contact us.
          </p>
          <img src={imageSix} alt="" className="w-fit h-fit" />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Staffing;
